import React from 'react';
import { useT } from '../../../../i18n';

const R = 46;
const C = 2 * Math.PI * R;
const POSTS = [
  { label: 'Lieu', share: 0.38, color: '#9E5462' },
  { label: 'Traiteur', share: 0.24, color: '#CFA0A9' },
  { label: 'Tenues', share: 0.14, color: '#2F7D5B' },
  { label: 'Photo', share: 0.1, color: '#C98A1E' },
];

// Budget : le donut se dessine poste par poste, puis un acompte passe en payé.
const BudgetVisual: React.FC = () => {
  const t = useT();
  let start = 0;
  return (
    <div className="mk-fv-stage">
      <div className="mk-fv-box mk-fv-budget">
        <span className="mk-fv-donut">
          <svg width="110" height="110" viewBox="0 0 110 110">
            <circle cx="55" cy="55" r={R} fill="none" stroke="#F1EAE5" strokeWidth="12" />
            {POSTS.map((p, i) => {
              const rotate = -90 + start * 360;
              start += p.share;
              return (
                <circle
                  key={p.label}
                  className={`mk-fv-arc mk-fv-arc${i}`}
                  cx="55"
                  cy="55"
                  r={R}
                  fill="none"
                  stroke={p.color}
                  strokeWidth="12"
                  style={{ '--len': `${p.share * C - 2}px`, '--c': `${C}px` } as React.CSSProperties}
                  transform={`rotate(${rotate} 55 55)`}
                />
              );
            })}
          </svg>
          <span className="mk-fv-donut-center">
            <span className="mk-fv-pct" />
            <em>{t('engagé')}</em>
          </span>
        </span>
        <span className="mk-fv-legend">
          {POSTS.map((p) => (
            <span key={p.label}>
              <b style={{ color: p.color }}>●</b> {t(p.label)}
            </span>
          ))}
        </span>
      </div>
      <div className="mk-fv-box mk-fv-paid">
        <i>✓</i>
        <span>
          <b>{t('Acompte payé')}</b>
          <br />
          {t('Traiteur')} · 30 %
        </span>
      </div>
    </div>
  );
};

export default BudgetVisual;
